export function baseEnumListToOptions(list) {
  return (
    list &&
    list.map(baseEnum => ({
      value: baseEnum.id,
      label: baseEnum.description
    }))
  )
}
